import { Stack, Typography, Button } from '@mui/material';
import StepperDUC from "../duc/StepperDUC";
import { DownloadProcessSteps, stepLabels } from "./DataDownloadProcess";
import { colours } from '../../StyleConstants';
import Selector from './components/Selector';


const DatasetSelection = (props: any) => {

    const dummyData = [
        { title: props.info.release.split("-")[0] + "Genotyping Data", size: "517 GB", latest: true },
        { title: props.info.release.split("-")[0] + "Raw Data", size: "4 GB", latest: false },
        { title: props.info.release.split("-")[0] + "Minimally Processed Imaging Data Recommended", size: "8370 GB", latest: false },
        { title: props.info.release.split("-")[0] + "Minimally Processed Data Recommended", size: "8370 GB", latest: false },
        { title: props.info.release.split("-")[0] + "Genotyping Data", size: "517 GB", latest: false }
    ]

    const handleClickDataset = (datasetTitle: string) => {
        props.setFull(false)
        props.setInfo({ ...props.info, dataset: datasetTitle })
        props.setCurStep(DownloadProcessSteps.FileSelection);
    };

    const handleClickBack = () => {
        props.setCurStep(DownloadProcessSteps.ReleaseSelection)
    }

    const handleClickFull = () => {
        props.setFull(true)
        props.setCurStep(DownloadProcessSteps.DownloadDetails)
    }
    
    return (
        <Stack gap={3} sx={{ padding: 3 }}>
            <Stack flexDirection="column" gap={4} alignItems="center">
                <Typography
                    variant="h3"
                    fontWeight="600"
                    fontSize="40px"
                    textAlign="center"
                    color={colours.midnightBlue.blue}>
                    New Dataset Download
                </Typography>
                <StepperDUC
                    activeStep={DownloadProcessSteps.DatasetSelection}
                    stepLabels={stepLabels}
                />
            </Stack>

            <Stack direction="row" justifyContent="space-between" marginTop={3}>
                <Button
                    variant="tertiary"
                    onClick={() => handleClickBack()}
                >
                    Back
                </Button>
                <Button
                    variant="tertiary"
                    onClick={() => handleClickFull()}
                >
                    Download Full Dataset
                </Button>
            </Stack>

            <Stack direction="row" gap={3} sx={{ marginTop: 3 }}>
                <Stack flex={1}>
                    <Typography variant="h6" fontWeight="600" color={colours.orange.orange}>
                        Selected study
                    </Typography>
                    <Selector
                        title={props.info.study}
                        hover={false}
                        text="Information about the study"/>
                </Stack>

                <Stack flex={1}>
                    <Typography variant="h6" fontWeight="600" color={colours.orange.orange}>
                        Selected release
                    </Typography>
                    <Selector
                        title={props.info.release}
                        hover={false}
                        text="Information about the study"/>
                </Stack>

                <Stack flex={1}>
                    <Typography variant="h5" fontWeight="600" color={colours.midnightBlue.blue}>
                            Select dataset
                    </Typography>
            

                    <Stack gap={2} sx={{ width: '100%' }}>
                        {dummyData.map((dataset) => (
                            <Selector
                                key={dataset.title}
                                hover={true}
                                title={dataset.title}
                                handleClick={handleClickDataset}
                                clickInfo={dataset.title}
                                text="Information about the study"
                            />
                        ))}
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    )
}

export default DatasetSelection;
